import React from 'react'
import TextField from "../../../fields/TextField"
import SelectField from "../../../fields/SelectField"
import { buildOptions } from "../../../utils"

export function RecoveryInformation() {
  const meetingOptions = buildOptions(["AA", "NA", "SLAA", "CODA", "Refuge Recovery"])
  return (
    <div className="p-4">
      <TextField name="step" label="Step" action="edit" col="none" />
      <SelectField
        name="kinds_of_meetings_attended_list"
        label="Kinds of Meetings Attended"
        action="edit"
        col="none"
        isMulti={true}i
        creatable={true}
        options={meetingOptions} />
    </div>
  )
}
